import CreateBulk from './CreateBulk';

export default CreateBulk;
